import {AppParamsContext} from 'contexts/AppParamsContext';
import {useContext} from 'react';
import {appMenuElements} from 'views/MoreMenu/V2ListingAppMenu/Elements';
import {useNavigate} from 'react-router-dom';
import {useClient, useDictionary} from '@adamlip/okeoke.client';
import IconComponent from 'components/IconComponent';

function V2ListingAppMenu({onSelect}) {
  const {appParams} = useContext(AppParamsContext);
  const {getValue} = useDictionary();
  const {getName} = useClient();
  const capitalize = appParams?.styles?.fonts?.capitalize;
  const style = appParams?.navigation?.appMenuSettings?.enabled !== true ? appParams?.navigation?.appMenu?.layout : appParams?.navigation?.appMenuSettings?.layout;

  const navigate = useNavigate();

  return (
    <>
      {appParams?.navigation?.appMenu
        ?.sort((a, b) => a?.idx - b?.idx)
        ?.map((item, index) => {
          return (
            <div
              className={`flex text-lg items-center gap-2 ${capitalize ? 'uppercase' : ''} ${appParams?.navigation?.appMenuSettings?.layout === 'grid' ? 'flex-col' : 'flex-row'}`}
              key={index}
              onClick={() => {
                let thisType = appMenuElements?.find((element) => element.key === item.key)?.onSelect;
                if (thisType === 'openModal') {
                  onSelect(item.key);
                } else {
                  if (item?.key === 'customExternalLink') {
                    window.open(item?.navTo);
                  } else if (item?.key === 'privacyLink') {
                    window.open(appParams?.others?.privacyLink || 'https://download.okeoke.io/docs/policy.pdf');
                  } else {
                    navigate(item?.navTo);
                  }
                }
              }}>
              <div
                style={{
                  backgroundColor: item?.bgColor ? `${item?.bgColor}` : '',
                  color: item?.iconColor ? `${item?.iconColor}` : '',
                }}
                className={`p-2  rounded-lg ${item?.bgColor ? ` ` : 'bg-primary/20 '} ${item?.iconColor ? `` : ' text-primary-foreground'}`}>
                <div className='w-6 h-6'>
                  <IconComponent iconCode={item?.icon} className={'current'} />
                </div>
              </div>
              <div className={`flex flex-col text-center ${style === 'grid' ? 'w-[76px]' : ''} leading-none`} style={{fontSize: style === 'grid' ? '12px' : '18px'}}>
                {item?.key === 'customExternalLink' ? getName(item?.label) : getValue(`app_v2_${item?.key}_accordionHeaderLabel`)}
              </div>
            </div>
          );
        })}
    </>
  );
}

export default V2ListingAppMenu;
